module.exports = __webpack_public_path__ + "img/PP_Sword_0363.86eed25e.png";